import { useEffect, useState } from "react";
import { useSyncStatus, pendingCount } from "../lib/sync";

const META = {
  live: { cls: "ok", label: "Live sync", title: "Changes are shared with every party via D1." },
  syncing: { cls: "warn", label: "Syncing…", title: "Pushing your latest changes." },
  error: { cls: "danger", label: "Sync offline", title: "Couldn't reach the server — retrying. Changes are kept locally." },
  local: { cls: "", label: "Local only", title: "No database reachable — data stays in this browser." },
  signedout: { cls: "danger", label: "Sign in again", title: "This device's sign-in has expired — nothing new is coming in until you sign in again." },
  offline: { cls: "warn", label: "Offline", title: "No signal. Everything you record is saved on this device and goes up by itself when you're back." },
} as const;

/** Sync state, and — when there is work waiting — how much. Somebody filing a
    report in a dead spot needs to know it was kept, not wonder. */
export function SyncBadge({ size = 10.5 }: { size?: number }) {
  const s = useSyncStatus();
  const [pending, setPending] = useState(pendingCount());

  // the queue drains outside React; poll it while anything is waiting
  useEffect(() => {
    const f = () => setPending(pendingCount());
    f();
    const t = setInterval(f, 2000);
    return () => clearInterval(t);
  }, [s]);

  const m = META[s];
  const waiting = (s === "offline" || s === "error" || s === "syncing") && pending > 0;

  return (
    <span
      className={"badge " + m.cls}
      title={waiting
        ? `${m.title}\n\n${pending} change${pending === 1 ? "" : "s"} waiting to upload.`
        : m.title}
      style={{ fontSize: size }}
    >
      <span className="dot" style={s === "live" ? { animation: "pulseDot 1.8s infinite" } : undefined} />
      {m.label}{waiting ? ` · ${pending}` : ""}
    </span>
  );
}
